function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import UnorderedList from '@govuk-react/unordered-list';
import { NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledContainer = styled('div')({
  fontFamily: NTA_LIGHT
});
var StyledDefinition = styled('li')({
  fontSize: '24px',
  fontWeight: 700,
  lineHeight: 1.25,
  '> a': {
    textDecoration: 'none'
  }
});
/**
 *
 * ### Usage
 *
 *
 * Simple
 * ```jsx
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorTag = asAnchor('a');
 * const fromData = [
 *   <AnchorTag href="/government/organisations/ministry-of-defence">
 *     Ministry of Defence
 *   </AnchorTag>,
 * ];
 *
 * <DocumentFooterMetadata from={fromData} />
 * ```
 *
 *
 * DFM From & part of example
 * ```jsx
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorTag = asAnchor('a');
 * const fromData = [
 *   <AnchorTag href="/government/organisations/ministry-of-defence">
 *     Ministry of Defence
 *   </AnchorTag>,
 * ];
 * const partOfData = [
 *   <AnchorTag href="/government/topics/energy">Energy</AnchorTag>,
 *   <AnchorTag href="/government/topics/environment">Environment</AnchorTag>,
 * ];
 *
 * <DocumentFooterMetadata from={fromData} partOf={partOfData} />
 * ```
 *
 *
 * DFM From & other data example
 * ```jsx
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorTag = asAnchor('a');
 * const fromData = [
 *   <AnchorTag href="/government/organisations/ministry-of-defence">
 *     Ministry of Defence
 *   </AnchorTag>,
 * ];
 * const otherData = [
 *   {
 *     id: 0,
 *     title: 'Consultation type',
 *     content: <AnchorTag href="/government/publications">Open</AnchorTag>,
 *   },
 *   {
 *     id: 1,
 *     title: 'Published',
 *     content: '20 January 2012',
 *   },
 * ];
 *
 * <DocumentFooterMetadata from={fromData} other={otherData} />
 * ```
 *
 * ### References:
 * - https://govuk-static.herokuapp.com/component-guide/document_footer
 */

var DocumentFooterMetadata = function DocumentFooterMetadata(_ref) {
  var from = _ref.from,
      partOf = _ref.partOf,
      other = _ref.other,
      props = _objectWithoutProperties(_ref, ["from", "partOf", "other"]);

  var fromData = React.createElement(StyledContainer, props, from && React.createElement("div", null, React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "From:"), React.createElement(UnorderedList, {
    listStyleType: "none"
  }, from && from.map(function (child, i) {
    return (
      /* eslint-disable react/no-array-index-key */
      React.createElement(StyledDefinition, {
        key: i
      }, child)
      /* eslint-enable react/no-array-index-key */

    );
  }))));
  var partOfData = React.createElement(StyledContainer, null, partOf && React.createElement("div", null, React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Part of:"), React.createElement(UnorderedList, {
    listStyleType: "none"
  }, partOf && partOf.map(function (child, i) {
    return React.createElement(StyledDefinition, {
      key: child.key || i
    }, child);
  }))));
  var otherData = React.createElement(StyledContainer, null, other && other.map(function (item) {
    return React.createElement("div", {
      key: item.id
    }, React.createElement("p", {
      style: {
        marginBottom: 0
      }
    }, item.title, ":"), React.createElement(UnorderedList, {
      listStyleType: "none"
    }, React.createElement(StyledDefinition, null, item.content)));
  }));
  return React.createElement("div", null, fromData, partOfData, otherData);
};

DocumentFooterMetadata.defaultProps = {
  from: undefined,
  partOf: undefined,
  other: undefined
};
export default withWhiteSpace({
  marginBottom: 0
})(DocumentFooterMetadata);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/document-footer-metadata/es/index.js
// module id = 281
// module chunks = 0